import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class ClienteService {

  constructor(private config: ConfigService,
    private http: HttpClient) { }


  getPossibleEntryChannel(token: string) {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/Cliente/CanalIngreso";
    return this.http.get(url, requestOptions);
  }

  getTypeIndetification(token: string) {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/Cliente/TipoIdentificacion";
    return this.http.get(url, requestOptions);
  }

  getClients(token: string, type: number, numberId: string) {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/Cliente/" + type + "/" + numberId;
    return this.http.get(url, requestOptions);
  }


  /// busqueda de clients
  getProspectiveClients(token: string, filter: string) {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/Cliente/" + filter;
    return this.http.get(url, requestOptions);
  }

  setClient(token: string, data: any) {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/Cliente";
    return this.http.post(url, data, requestOptions);
  }

  setChannelEntryClient(token: string, data: any) {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/Cliente/Channel";
    return this.http.post(url, data, requestOptions);
  }



}
